module.exports = __webpack_public_path__ + "img/vertical_7_4_9016.fd097fbc.png";